import { PackType } from 'src/api/types';
import { FetchAttr } from '../types';
import { postData } from '../utils';

type PostClientCartItem = {
  translitName: string;
  packQuantity: number;
  unitQuantity?: number;
  packType: PackType;
};

export type PostClientInfoResponse = {
  status: number;
};

const postClientCart = async (
  requestObj: PostClientCartItem[],
  attr?: FetchAttr
): Promise<PostClientInfoResponse> => {
  const response = await postData(`client/cart`, { drugs: requestObj }, attr);
  return response;
};

export default postClientCart;
